import { ImagePixels } from '../../lib/brdocs';
import { fileToCanvas } from '../shared/pdf';

/** Renders an uploaded image/PDF file to pixels (PDF → first page). */
export async function fileToPixels(file: Blob): Promise<ImagePixels> {
  const canvas = await fileToCanvas(file);
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  if (!ctx) {
    throw new Error('Could not get a 2D canvas context');
  }
  return ctx.getImageData(0, 0, canvas.width, canvas.height);
}

/** Extracts pixels from a canvas (e.g. a grabbed webcam frame). */
export function canvasToPixels(canvas: HTMLCanvasElement): ImagePixels {
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  if (!ctx) {
    throw new Error('Could not get a 2D canvas context');
  }
  return ctx.getImageData(0, 0, canvas.width, canvas.height);
}
